<template>
  <div class="online-payment-policy">
    <collapsed-setting-card
      :title="$t('payment.active-cancel-refund')"
    >
      <div class="payment-policy-terms">
        <div class="payment-policy-content">
          <p class="payment-policy-title">
            {{ $t('payment.activation') }}
          </p>
          <p class="payment-policy-description">
            {{ activation }}
          </p>
        </div>
      </div>
      <div class="payment-policy-terms">
        <div class="payment-policy-content">
          <p class="payment-policy-title">
            {{ $t('payment.cancellation') }}
          </p>
          <p class="payment-policy-description">
            {{ $t('payment.cancellation-hint') }}
          </p>
        </div>
      </div>
      <div class="payment-policy-terms">
        <div class="payment-policy-content">
          <p class="payment-policy-title">
            {{ $t('payment.refund') }}
          </p>
          <p class="payment-policy-description">
            {{ $t('payment.no-refund') }}
          </p>
        </div>
      </div>
    </collapsed-setting-card>
  </div>
</template>

<script>
import CollapsedSettingCard from '@/@okmenu/components/cards/CollapsedSettingCard'

export default {
  name: 'PaymentPolicy',
  components: {
    CollapsedSettingCard,
  },
  props: {
    addons: {
      type: Array,
      default: () => [],
    },
    upgrade: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    activation() {
      if (this.addons.length === 1 && this.addons[0].slug === 'google') return this.$t('google-menu.activation')
      return this.$t('payment.available-after-purchasing')
    },
  },
}
</script>

<style lang="scss">
.payment-policy-terms {
  margin: 0 30px;
  .payment-policy-title{
    font-size: 20px;
    font-weight: 600;
    line-height: 1.75;
    margin: 0;
  }
  .payment-policy-description{
    max-height: 382px;
    line-height: 1.56;
    font-size: 17px;
    font-weight: 500;
    margin: 0;
  }
  .payment-policy-content{
    margin-bottom: 20px;
  }
}
</style>
